import React from 'react'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { getDateRangeText } from 'shared/utils/dates'
import { SlantBackground, SlantBackgroundImage } from '../SlantBackground'
import { Hero } from '../Hero'
import TopBrands from '../brands/TopBrands'
import TeamBio from '../TeamBio'
import WorkshopDaysOfWeek from './WorkshopDaysOfWeek'
import WorkshopBody from './WorkshopBody'

function WorkshopEventPage({ pageContext: ws }) {
  return (
    <div className="spacing-giant">
      <Hero>
        <div className="spacing">
          <div>
            <strong>Public Workshop:</strong>
            <Heading className="text-color-blue">
              <span className="text-xlarge">{ws.title}</span>
            </Heading>
            <span className="block horizontal-spacing-small">
              <strong>{ws.minutes > 0 ? `${ws.minutes} Minutes` : `${ws.days} Day`}:</strong>
              <span>{ws.subTitle}</span>
            </span>
          </div>
          <div>
            <div>{getDateRangeText(ws.startDate, ws.days)}</div>
            <em className="text-small block">
              {ws.startTime} - {ws.endTime} {ws.remoteTimezone && ws.remoteTimezone}
            </em>
          </div>
          <div className="text-small">
            <WorkshopDaysOfWeek startDate={ws.startDate} days={ws.days} />
          </div>
        </div>
      </Hero>

      <SlantBackground verticalOffset={-7} shallowSlant>
        <SlantBackgroundImage src="/images/react-gray-two.svg" />
      </SlantBackground>

      <Centered>
        <WorkshopBody ws={ws} />

        <hr />
        <section>
          <TopBrands />
        </section>
        <hr />
        <section className="spacing">
          <Heading as="h2" size={2}>{`Instructor${ws.instructors.length > 1 ? 's' : ''}`}</Heading>
          <div className="spacing-large">
            {ws.instructors.map((teamMemberId) => {
              return <TeamBio key={teamMemberId} id={teamMemberId} url={`/team/${teamMemberId}`} />
            })}
          </div>
        </section>
      </Centered>
    </div>
  )
}

export default WorkshopEventPage
